import { Spoiler, UnstyledButton } from '@mantine/core';
// icons
import { Pencil, Trash2 } from 'lucide-react';
// components
import { PopoverButton } from '@newo/ui-kit';
// utils
import type { TSkillParameter, TSkillParameterData } from '@newo/api/gateway';
import ParameterForm from '@/modules/Designer/components/Parameters/components/ParameterForm';

interface ParameterItemProps {
    parameter: TSkillParameter;
    onDelete: (parameter: TSkillParameter) => void;
    onUpdate: (
        data: TSkillParameterData,
        parameterId?: string
    ) => Promise<unknown>;
}

const ParameterItem = ({
    parameter,
    onDelete,
    onUpdate
}: ParameterItemProps) => {
    const handleDelete = () => {
        onDelete(parameter);
    };

    return (
        <div className="group text-xs px-3 py-2 hover:bg-gray-1">
            <div className="flex gap-2 items-center">
                <div className="flex-1 w-[28ch] font-bold whitespace-nowrap overflow-hidden overflow-ellipsis">
                    {parameter.name}
                </div>

                <PopoverButton
                    className="opacity-0 transition-opacity duration-200 group-hover:opacity-100"
                    title="Edit Parameter"
                    trapFocus={false}
                    trigger={<Pencil className="text-xs" />}
                >
                    {(close) => (
                        <ParameterForm
                            parameter={parameter}
                            onCancel={close}
                            onSubmit={onUpdate}
                        />
                    )}
                </PopoverButton>
                <UnstyledButton
                    className="opacity-0 transition-opacity duration-200 group-hover:opacity-100"
                    title="Delete Parameter"
                    onClick={handleDelete}
                >
                    <Trash2 className="text-xs" />
                </UnstyledButton>
            </div>

            <Spoiler hideLabel="Hide" maxHeight={50} showLabel="Show more">
                <div className="break-all text-dark-4 text-xs/4">
                    {parameter.default_value}
                </div>
            </Spoiler>
        </div>
    );
};

export default ParameterItem;
